export default {
    data() {
        return {
            //项目包id
            id: '',
            //项目包数据
            projectList: [],
            //控制上面tab的切换
            isTab: 1,
            // 表格数据
            tableData: [],
            // 轮播图数据
            bannerList: [],
            // 通知数据
            notices: [],
            // 指南数据
            newsList: [],
            imgUrl: this.imgUrl,
            bannerUrl: this.bannerUrl,
            headerImg: '',
            allTableData: [],
        }
    },
    methods: {
        // 获取项目包数据
        getPackage() {
            this.$post('package/search', {
                token: this.$store.state.id,
                offset: 0,
                length: 9999,
                id: this.id
            }).then(res => {
                this.projectList = res.data.result.data[0];
                // console.log(this.projectList);
                // this.tableData = this.projectList.package_product
            })
        },

        // 获取轮播图
        getBanner() {
            this.$post('product_small_banner/search', {
                offset: 0,
                length: 9999,
                package_id: this.id
            }).then(res => {
                this.bannerList = res.data.result.data
            })
        },

        // 获取通知
        getNotices() {
            this.$post('product_notices/search', {
                token: this.$store.state.id,
                offset: 0,
                length: 9999,
                package_id: this.id
            }).then(res => {
                this.notices = res.data.result.data
                // console.log('通知')
                // console.log(this.notices)
            })
        },

        // 获取项目包指南
        getNews() {
            this.$post('product_news/search', {
                token: this.$store.state.id,
                offset: 0,
                length: 9999,
                package_id: this.id
            }).then(res => {
                this.newsList = res.data.result.data
                // console.log('项目包指南')
                // console.log(this.newsList)
            })
        },


        // 跳转到项目学习页
        toProjectStudy(res) {
            // console.log('点击', res)
            // console.log(res.product_id)
            // console.log(res.is_project)
            this.$toClass(res.product_id, res.is_project)
            // let address = this.$router.resolve({
            //       path: '/lessonstudy',
            //       query: {
            //       }
            //   });
            //   window.open(address.href,"_blank");
        },
        //改变控制切换栏的变量
        // changeTab() {
        //     console.log(this.isTab)
        // },

        //请求本人在这个项目包已经购买的项目
        hadBuyPackageProject() {
            //请求给后台的数据
            let data = {
                token: this.$store.state.id,
                package_id: this.id,
                offset: 0,
                length: 999,
            }
            this.$post("purchased/search_by_userId_and_packageId", data).then(res => {
                // console.log('444', res.data.result.data);
                this.tableData = res.data.result.data;
				// console.log('tabledata',this.tableData)
            })
        },
        //请求平台所有项目
        allPackageProject() {
            let data = {
                package_id: this.id,
                length: 999,
                offset: 0
            }
            this.$post("package_product/search", data).then(res => {
                // console.log('all', res.data.result.data)
                this.allTableData = res.data.result.data
            })
        },

        // 点击通知或指南进行跳转到详情页面
        handleClick(type, index) {
            this.$router.push({
                path: '/projectnews',
                query: {
                    id: this.id,
                    type: type,
                    index: index
                }
            })
        }
    },
    created() {
        this.id = this.$route.query.id
        this.getPackage()
        this.getBanner()
        this.getNotices()
        this.getNews()
        this.hadBuyPackageProject();
        this.allPackageProject()

    },
    computed: {
        packageYear() {
            if (this.projectList.start_stydy_time !== null) {
                return String(this.projectList.start_stydy_time).substr(0, 4);
            }
        }
    },
}
